import React from 'react';

function About() {
  return (
    <div>
      {/* Page hero */}
      <div className="lb-page-hero">
        <div className="lb-container">
          <p className="lb-eyebrow">About</p>
          <h1 className="lb-title-lg">서비스 소개</h1>
          <p className="lb-body">노후 준비 연금 계산기를 만든 이유와 목적</p>
        </div>
      </div>

      <section className="lb-section">
        <div className="lb-container" style={{ maxWidth: '800px' }}>

          {/* 서비스 소개 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <p className="lb-eyebrow">Service</p>
            <h2 className="lb-title-md" style={{ marginTop: '8px', marginBottom: '16px' }}>
              노후 준비 연금 계산기란?
            </h2>
            <p className="lb-body" style={{ marginTop: 0 }}>
              라떼비버 노후연금 계산기는 <strong>두 가지 방식으로 노후 자금을 계획</strong>할 수 있는 전문 웹 서비스입니다.
              복리 계산과 현금흐름 시뮬레이션을 통해 실질적인 노후 준비 계획을 세울 수 있도록 도와드립니다.
            </p>

            <div className="lb-grid-2" style={{ marginTop: '20px' }}>
              <div className="lb-card lb-card-padded">
                <div className="lb-card-icon">🧮</div>
                <h3 className="lb-title-md" style={{ marginTop: '8px' }}>일반 계산기</h3>
                <p className="lb-card-desc">매월 저축 가능한 금액에서 출발하여 노후에 사용할 수 있는 생활비를 계산합니다.</p>
              </div>
              <div className="lb-card lb-card-padded">
                <div className="lb-card-icon">🎯</div>
                <h3 className="lb-title-md" style={{ marginTop: '8px' }}>역산 계산기</h3>
                <p className="lb-card-desc">원하는 노후 생활비에서 출발하여 현재부터 필요한 월 저축액을 계산합니다.</p>
              </div>
            </div>
          </div>

          {/* 서비스 특징 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <p className="lb-eyebrow">Features</p>
            <h2 className="lb-title-md" style={{ marginTop: '8px', marginBottom: '20px' }}>서비스 특징</h2>
            <div className="lb-grid-3">
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '36px', marginBottom: '12px' }}>📈</div>
                <h3 className="lb-title-md">정확한 복리 계산</h3>
                <p className="lb-card-desc">복리 수익률과 배당 수익률을 분리하여 더욱 정확한 시뮬레이션을 제공합니다.</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '36px', marginBottom: '12px' }}>📊</div>
                <h3 className="lb-title-md">시각적 데이터</h3>
                <p className="lb-card-desc">Chart.js 그래프와 상세 테이블로 계산 결과를 직관적으로 확인할 수 있습니다.</p>
              </div>
              <div style={{ textAlign: 'center' }}>
                <div style={{ fontSize: '36px', marginBottom: '12px' }}>📱</div>
                <h3 className="lb-title-md">반응형 디자인</h3>
                <p className="lb-card-desc">PC, 태블릿, 모바일 모든 기기에서 최적화된 경험을 제공합니다.</p>
              </div>
            </div>
          </div>

          {/* 계산 방식 */}
          <div className="lb-card lb-card-padded" style={{ marginBottom: '24px' }}>
            <p className="lb-eyebrow">Method</p>
            <h2 className="lb-title-md" style={{ marginTop: '8px', marginBottom: '16px' }}>계산 방식 및 가정</h2>

            <div className="lb-alert lb-alert-info" style={{ marginBottom: '20px' }}>
              ℹ️ <strong>중요 안내</strong>: 이 계산기는 교육 및 참고 목적으로만 사용하시기 바랍니다.
              실제 투자 결정 시에는 반드시 금융 전문가와 상담하시기 바랍니다.
            </div>

            <h3 className="lb-title-md" style={{ marginBottom: '12px' }}>📐 계산 공식</h3>
            <div style={{ marginBottom: '20px' }}>
              <div className="lb-detail-item">
                <span className="lb-detail-label">복리 계산</span>
                <span className="lb-detail-value" style={{ fontSize: '13px', fontFamily: 'monospace' }}>
                  FV = PMT × [((1+r)^n − 1) / r]
                </span>
              </div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">현금흐름</span>
                <span className="lb-detail-value" style={{ fontSize: '13px' }}>최종 적립액 × 연배당률 ÷ 12개월</span>
              </div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">시뮬레이션</span>
                <span className="lb-detail-value" style={{ fontSize: '13px' }}>연도별 적립 과정 시각화</span>
              </div>
            </div>

            <h3 className="lb-title-md" style={{ marginBottom: '12px' }}>⚠️ 주요 가정사항</h3>
            <ul style={{ paddingLeft: '18px', color: 'var(--color-text-sub)', lineHeight: '2', fontSize: '15px' }}>
              <li>수익률은 매년 일정하다고 가정 (실제로는 변동)</li>
              <li>인플레이션은 고려하지 않음</li>
              <li>세금 및 수수료는 별도 계산 필요</li>
              <li>매월 일정한 금액을 저축한다고 가정</li>
            </ul>
          </div>

          {/* 개발 정보 */}
          <div className="lb-card lb-card-padded">
            <p className="lb-eyebrow">Tech</p>
            <h2 className="lb-title-md" style={{ marginTop: '8px', marginBottom: '16px' }}>개발 정보</h2>
            <div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">프론트엔드</span>
                <span className="lb-detail-value">React.js</span>
              </div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">인프라</span>
                <span className="lb-detail-value">Firebase Hosting</span>
              </div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">차트</span>
                <span className="lb-detail-value">Chart.js</span>
              </div>
              <div className="lb-detail-item">
                <span className="lb-detail-label">디자인 시스템</span>
                <span className="lb-detail-value">lb-design-system (라떼비버 브랜드)</span>
              </div>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}

export default About;
